/**
 * Contact page (sections/bjaf-contact.liquid).
 * - ?topic=<topic block id> in the URL picks that topic (the returns and track pages link with it).
 * - Topic chips: swap the message placeholder to the topic's own text, and turn the order number field off when the
 *   topic doesn't ask for it (CSS hides it; disabling keeps an empty field out of the email).
 * - Thank-you screen: Shopify reloads the page after sending, so the name and dog's name are kept in sessionStorage
 *   on submit and put into [name] / [dog] in the thank-you texts (as text, never HTML).
 */
(function () {
  var KEY = 'bjaf_contact_names';

  function store(get) {
    try { return get(window.sessionStorage); } catch (e) { return null; }
  }

  function initForm(form) {
    var body = form.querySelector('[data-bjaf-contact-body]');
    var orderWrap = form.querySelector('[data-bjaf-contact-order]');
    var orderInput = orderWrap ? orderWrap.querySelector('input') : null;
    var radios = form.querySelectorAll('input[name="contact[Topic]"]');

    function sync() {
      var picked = form.querySelector('input[name="contact[Topic]"]:checked');
      if (body) {
        var ph = picked && picked.getAttribute('data-placeholder');
        body.placeholder = ph || body.getAttribute('data-default-placeholder') || '';
      }
      if (orderInput) orderInput.disabled = !(picked && picked.hasAttribute('data-order'));
    }

    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', sync);

    // ?topic=<topic block id> (e.g. topic_returns from the returns page) picks that topic.
    var wanted = null;
    try { wanted = new URLSearchParams(window.location.search).get('topic'); } catch (e) { wanted = null; }
    if (wanted) {
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].getAttribute('data-topic-id') === wanted) radios[j].checked = true;
      }
    }
    sync();

    form.addEventListener('submit', function () {
      var name = form.querySelector('[data-bjaf-contact-name]');
      var dog = form.querySelector('[data-bjaf-contact-dog]');
      var data = JSON.stringify({
        name: name ? name.value.trim().split(/\s+/)[0] : '',
        dog: dog ? dog.value.trim() : ''
      });
      store(function (s) { s.setItem(KEY, data); });
    });
  }

  function initDone(done) {
    var raw = store(function (s) { var v = s.getItem(KEY); s.removeItem(KEY); return v; });
    var data = {};
    try { data = JSON.parse(raw || '{}') || {}; } catch (e) { data = {}; }

    var heading = done.querySelector('.bjaf-ct__done-h');
    if (heading && data.name) {
      var named = heading.getAttribute('data-named') || '';
      if (named.indexOf('[name]') > -1) heading.textContent = named.split('[name]').join(data.name);
    }
    var dogLine = done.querySelector('.bjaf-ct__done-dog');
    if (dogLine && data.dog) {
      var text = dogLine.getAttribute('data-text') || '';
      if (text.indexOf('[dog]') > -1) {
        dogLine.textContent = text.split('[dog]').join(data.dog);
        dogLine.hidden = false;
      }
    }
    done.focus({ preventScroll: true });
  }

  function init() {
    var forms = document.querySelectorAll('[data-bjaf-contact] form');
    for (var i = 0; i < forms.length; i++) {
      var done = forms[i].querySelector('[data-bjaf-contact-done]');
      if (done) initDone(done); else initForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
